import Errors from "../legal_entity/Errors";

const errorMessage = (data, callback) => {
    let message = 'Помилка!\n';

    if (data.error && data.error.invalid && data.error.invalid.length > 0) {
        for (let i = 0; i < data.error.invalid.length; i++) {
            let key = data.error.invalid[i].rules[0].description;

            if (data.error.invalid[i].entry) {
                if (typeof Errors[key] === 'undefined') {
                    message = message + data.error.invalid[i].entry + ': ' + key + '\n';
                } else {
                    message = message + (key !== 'value is not allowed in enum' ? data.error.invalid[i].entry + ': ' : '') + Errors[key];
                }
            } else if (data.error.message) {
                let key = data.error.message

                if (typeof Errors[key] === 'undefined') {
                    message = message + data.error.message;
                } else {
                    message = message + Errors[key];
                }
            }
        }
    } else if (data.error.message) {
        let key = data.error.message

        if (typeof Errors[key] === 'undefined') {
            message = message + data.error.message;
        } else {
            message = message + Errors[key];
        }
    } else if (data.message) {
        let key = data.message

        if (typeof Errors[key] === 'undefined') {
            message = message + key;
        } else {
            message = message + Errors[key];
        }
    }

    callback(message);
}

export default errorMessage;
